module.exports = __webpack_public_path__ + "static/media/14-M-Cure 1.280e19e8.jpg";